module.exports = __webpack_public_path__ + "img/skanska_s_letter.cbf3692d.jpeg";